/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Box from "@material-ui/core/Box"
import { Container } from "@material-ui/core"
import { useLocation } from "react-router-dom"
import PageSubTitle from "../../component/header/PageSubTitle"
import Widget from "./Widget"
import useSmartFormat from "../../i18n/useSmartFormat"
import httpClient from "../../api/httpClient"

export default function TemplateWealthPage({
  children,
  subtitle,
  renderSelector,
  TabContentDSL
}) {
  const format = useSmartFormat()
  const location = useLocation()
  const pageIdentifier = location.pathname.split("/")[2]
  const [hasMax, setHasMax] = useState(false)
  useEffect(() => {
    httpClient.get(`/api/page/${pageIdentifier}`).then(({ data }) => {
      setHasMax(data.dateIsLimited)
    })
  }, [pageIdentifier])
  return (
    <Box py={3}>
      <Container maxWidth="lg">
        <Box display="flex" justifyContent="center">
          {renderSelector?.({ hasMax })}
        </Box>
        <PageSubTitle subtitle={format(subtitle)} />
        {children}
      </Container>
      <Container maxWidth="xl">
        {TabContentDSL.map((it) => (
          <Widget key={it.alias} {...it} />
        ))}
      </Container>
      {/* If you wan to add more dedicated widgets:
            1/ Try to add them in configuration (see: src/pages/wealth/pages.js)
            2/ Otherwise develop a specific layout for it
       */}
    </Box>
  )
}

TemplateWealthPage.propTypes = {
  widgetPage: PropTypes.any.isRequired, // FIXME SR
  subtitle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired
  }).isRequired,
  selectorReducerName: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  renderSelector: PropTypes.func,
  TabContentDSL: PropTypes.array.isRequired
}

TemplateWealthPage.defaultProps = {
  children: null,
  renderSelector: undefined
}
